// extracted by mini-css-extract-plugin
export var centerList = "_a1-7";
export var centerLoc = "_a1-b";
export var centerName = "_a1-a";
export var centerOptionBody = "_a1-9";
export var centerRow = "_a1-8";
export var centerStatus = "_a1-c";
export var empty = "_a1-6";
export var externalIcon = "_a1-d";
export var fieldCount = "_a1-4";
export var fieldHeader = "_a1-2";
export var fieldHelp = "_a1-5";
export var fieldLabel = "_a1-3";
export var panel = "_a1-0";
export var removeBtn = "_a1-e";
export var section = "_a1-1";